const DOMAINS = [
  'gmail.com', 'googlemail.com', 'gmx.de', 'gmx.net', 'gmx.at', 'gmx.ch', 'web.de', 't-online.de', 'outlook.com', 'outlook.de',
  'hotmail.com', 'hotmail.de', 'live.com', 'live.de', 'yahoo.com', 'yahoo.de', 'icloud.com', 'me.com', 'freenet.de', 'aol.com',
  'posteo.de', 'mail.de', 'arcor.de', 'protonmail.com', 'proton.me', 'online.de', 'email.de', 'kanzlei-partner.com',
];
const AUCH_GUELTIG = ['mail.com', 'email.com', 'gmx.com', 'gmx.org', 'web.com', 'live.at', 'live.fr', 'yahoo.fr', 'yahoo.it', 'hotmail.fr', 'hotmail.it',
  'outlook.fr', 'outlook.at', 'libero.it', 'orange.fr', 'free.fr', 'laposte.net', 'mail.ru', 'yandex.com', 'msn.com', 'mac.com', 'aol.de'];
const TLD_FIX = {
  dee: 'de', ed: 'de', dd: 'de', dr: 'de', ded: 'de', con: 'com', cmo: 'com', comm: 'com', cm: 'com', om: 'com', vom: 'com', xom: 'com',
  ocm: 'com', coom: 'com', nett: 'net', ent: 'net', nte: 'net', met: 'net', orgg: 'org', ogr: 'org',
};

const distanz = (a, b) => {
  const d = Array.from({ length: a.length + 1 }, (_, i) => [i, ...Array(b.length).fill(0)]);
  for (let j = 1; j <= b.length; j += 1) d[0][j] = j;
  for (let i = 1; i <= a.length; i += 1) {
    for (let j = 1; j <= b.length; j += 1) {
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
    }
  }
  return d[a.length][b.length];
};

const naechsteDomain = (domain) => {
  let best = null;
  let min = Infinity;
  DOMAINS.forEach((k) => { const x = distanz(domain, k); if (x < min) { min = x; best = k; } });
  return min > 0 && min <= (domain.length < 8 ? 1 : 2) ? best : null;
};

export const emailVorschlag = (wert) => {
  const v = (wert || '').trim();
  const at = v.lastIndexOf('@');
  if (at < 1 || at === v.length - 1) return null;
  const lokal = v.slice(0, at);
  const domain = v.slice(at + 1).toLowerCase();
  if (DOMAINS.includes(domain) || AUCH_GUELTIG.includes(domain) || !/[a-z]/.test(domain)) return null;
  let neu = naechsteDomain(domain);
  if (!neu) {
    const teile = domain.split('.');
    const tld = teile.length > 1 ? teile.pop() : null;
    if (tld && TLD_FIX[tld]) {
      const fix = [...teile, TLD_FIX[tld]].join('.');
      neu = DOMAINS.includes(fix) ? fix : (naechsteDomain(fix) || fix);
    }
  }
  return neu && neu !== domain ? `${lokal}@${neu}` : null;
};
